(function(){
  function initCarousel(root){
    // Evitar re-inicialización
    if(root.dataset.initialized === 'true') return;
    root.dataset.initialized = 'true';

    const track = root.querySelector('.fcd-media-track');
    // Solo seleccionar slides originales (sin clones)
    const slides = Array.from(track.querySelectorAll('.fcd-media-slide:not(.cloned)'));
    const dotsContainer = root.querySelector('.fcd-media-dots');
    const autoplay = root.dataset.autoplay === 'true';
    const interval = parseInt(root.dataset.interval || '5000', 10);
    function computeVisible(){
      const w = root.clientWidth;
      if (w <= 475) return 1;
      if (w <= 768) return 3;
      if (w <= 1024) return 3;
      if (w <= 1200) return 4;
      return 5;
    }
    let visible = computeVisible();

    if(slides.length === 0) return;

    // Clonado para loop infinito (clonamos extremos)
    const prefix = slides.map(s => { const c = s.cloneNode(true); c.classList.add('cloned'); return c; });
    const suffix = slides.map(s => { const c = s.cloneNode(true); c.classList.add('cloned'); return c; });
    prefix.forEach(n => track.appendChild(n));
    suffix.reverse().forEach(n => track.insertBefore(n, track.firstChild));

    let allSlides = Array.from(track.children);
    let current = slides.length; // empezamos en el primer original centrado

    function slideWidth(){
      const first = allSlides[0];
      return first.getBoundingClientRect().width;
    }

    function setTransform(noAnim){
      if(noAnim) track.style.transition = 'none'; else track.style.transition = 'transform .5s ease';
      const w = slideWidth();
      let offset;
      
      if (visible === 1) {
        // En móvil, centrar el slide activo
        offset = -(current * w) + (root.clientWidth - w) / 2;
      } else {
        // En desktop/tablet, usar el cálculo normal
        offset = -(current - Math.floor(visible/2)) * w;
      }
      
      track.style.transform = `translateX(${offset}px)`;
      updateActive();
    }

    function updateActive(){
      allSlides.forEach(s => s.classList.remove('activo'));
      const centerIndex = current;
      const centerSlide = allSlides[centerIndex];
      if(centerSlide){
        centerSlide.classList.add('activo');
        toggleMedia(centerSlide, true);
      }
      // Pausar los no activos
      allSlides.forEach((s, idx) => { if(idx !== centerIndex) toggleMedia(s, false); });
      updateDots();
    }

    function toggleMedia(slide, play){
      const video = slide.querySelector('video');
      if(video){
        if(play){ video.play().catch(()=>{}); } else { video.pause(); video.currentTime = 0; }
      }
    }

    function next(){ current += 1; setTransform(false); fixLoop(); }
    function prev(){ current -= 1; setTransform(false); fixLoop(); }

    function fixLoop(){
      // cuando salimos del rango original, teletransportamos
      const total = allSlides.length;
      const originals = slides.length;
      const min = originals - 1; // por los clones al inicio
      const max = originals + (originals - 1) + (originals) - 1; // seguro sobra margen
      // Simplificamos: si current llega a total - originals, retrocede originals
      track.addEventListener('transitionend', onEnd, { once: true });
      function onEnd(){
        if (current < originals) { current += originals; setTransform(true); }
        if (current >= total - originals) { current -= originals; setTransform(true); }
      }
    }

    // Dots - Clear container first to prevent duplication
    dotsContainer.innerHTML = '';
    const dots = slides.map((s, i) => {
      const b = document.createElement('button');
      b.className = 'fcd-media-dot';
      b.addEventListener('click', () => { current = slides.length + i; setTransform(false); });
      dotsContainer.appendChild(b);
      return b;
    });
    function updateDots(){
      const idx = (current - slides.length) % slides.length;
      const normalized = (idx + slides.length) % slides.length;
      dots.forEach((d, i) => d.classList.toggle('activo', i === normalized));
    }

    // Drag / touch
    let startX = 0, delta = 0, dragging = false;
    function onStart(x){ dragging = true; startX = x; track.style.transition = 'none'; }
    function onMove(x){ 
      if(!dragging) return; 
      delta = x - startX; 
      const w = slideWidth(); 
      let offset;
      
      if (visible === 1) {
        // En móvil, centrar el slide activo
        offset = -(current * w) + (root.clientWidth - w) / 2 + delta;
      } else {
        // En desktop/tablet, usar el cálculo normal
        offset = -(current - Math.floor(visible/2)) * w + delta;
      }
      
      track.style.transform = `translateX(${offset}px)`; 
    }
    function onEnd(){ if(!dragging) return; dragging = false; if(Math.abs(delta) > 40){ delta < 0 ? next() : prev(); } else { setTransform(false); } delta = 0; }

    track.addEventListener('mousedown', e => { e.preventDefault(); onStart(e.clientX); });
    window.addEventListener('mousemove', e => onMove(e.clientX));
    window.addEventListener('mouseup', onEnd);
    track.addEventListener('touchstart', e => onStart(e.touches[0].clientX), { passive: true });
    window.addEventListener('touchmove', e => onMove(e.touches[0].clientX), { passive: false });
    window.addEventListener('touchend', onEnd);

    // autoplay
    let timer = null;
    function startAuto(){ if(autoplay){ stopAuto(); timer = setInterval(next, interval); } }
    function stopAuto(){ if(timer){ clearInterval(timer); timer = null; } }
    root.addEventListener('mouseenter', stopAuto);
    root.addEventListener('mouseleave', startAuto);

    // Inicial
    allSlides = Array.from(track.children);
    setTransform(true);
    updateDots();
    startAuto();
    window.addEventListener('resize', () => { visible = computeVisible(); setTransform(true); });
  }

  document.addEventListener('DOMContentLoaded', function(){
    document.querySelectorAll('.fcd-media-carousel').forEach(initCarousel);
  });
})();

